import { render } from "./AddChargingFacilities.vue?vue&type=template&id=2c10d834&scoped=true"
import script from "./AddChargingFacilities.vue?vue&type=script&lang=ts"
export * from "./AddChargingFacilities.vue?vue&type=script&lang=ts"

import "./AddChargingFacilities.vue?vue&type=style&index=0&id=2c10d834&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-2c10d834"

export default script